import type { TableRow } from "./product-route-contracts";

export const companies: TableRow[] = [
  { id: "company-1", name: "Acme Leadership", status: "active", scope: "assigned", cohorts: 1 }
];

export const cohorts: TableRow[] = [
  { id: "cohort-1", name: "Spring Leaders", company: "Acme Leadership", status: "active", participants: 1 }
];

export const sessions: TableRow[] = [
  { id: "session-1", title: "Session 1", cohort: "Spring Leaders", status: "scheduled", invite: "provider-closed" }
];

export const reports: TableRow[] = [
  { id: "report-1", title: "Session 1 Report", session: "Session 1", status: "ready" }
];

export const programs: TableRow[] = [
  { id: "program-1", name: "Executive Coaching", company: "Acme Leadership", status: "active" }
];

export const participants: TableRow[] = [
  { id: "participant-1", name: "Learner One", email: "learner@example.com", progress: "4 of 10 sessions" }
];

export const resources: TableRow[] = [
  { id: "resource-1", title: "Coaching primer", status: "published", access: "global read-only" }
];

export const history: TableRow[] = [
  { id: "event-1", action: "invite.requested", actor: "Admin Operator", summary: "Provider delivery remains closed." }
];

export const users: TableRow[] = [
  { id: "user-1", name: "Coach One", email: "coach@example.com", role: "coach", status: "active" }
];
